// Norway products are Thrillophilia imports only; Scandinavia combos are listed on every Nordic country they visit.
import { bestOfScandinavianNorwayFjordsProduct } from './bestOfScandinavianNorwayFjordsData';
import { norwegianEscapadeNorthernLightsProduct } from './norwegianEscapadeNorthernLightsData';
import { classicNorwayHurtigrutenFlamProduct } from './classicNorwayHurtigrutenFlamData';
import { norwegianHighlightsFjordsCoastProduct } from './norwegianHighlightsFjordsCoastData';
import { arcticNorwayWinterWonderlandProduct } from './arcticNorwayWinterWonderlandData';
import { southernNorwegianDelightsProduct } from './southernNorwegianDelightsData';
import { bestOfNorthernLightsNorway14DaysProduct } from './bestOfNorthernLightsNorway14DaysData';
import { finlandEscapadeLaplandInariProduct } from './finlandEscapadeLaplandInariData';
import { scandinaviaGroupTourHelsinkiCopenhagenProduct } from './scandinaviaGroupTourHelsinkiCopenhagenData';
import { scandinaviaClassicFlamRailwayProduct } from './scandinaviaClassicFlamRailwayData';

export const norwayProducts = [
  bestOfScandinavianNorwayFjordsProduct,
  norwegianEscapadeNorthernLightsProduct,
  classicNorwayHurtigrutenFlamProduct,
  norwegianHighlightsFjordsCoastProduct,
  arcticNorwayWinterWonderlandProduct,
  southernNorwegianDelightsProduct,
  bestOfNorthernLightsNorway14DaysProduct,
  finlandEscapadeLaplandInariProduct,
  scandinaviaGroupTourHelsinkiCopenhagenProduct,
  scandinaviaClassicFlamRailwayProduct
];
export const norwayTours = [];
export const norwayBySlug = {};
